import { useGetMember, useGetMemberMemo } from '#api/member';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import CustomerMemo from '../CustomerMemo';
import {
  ButtonText,
  Container5,
  Container6,
  Container8,
  CustomText,
  CustomTextArea,
  DefaultInfoText,
  DefaultInfoText2,
  RowDivider
} from '../styles';
import AdvanceInfo from './AdvanceInfo';
import FixCustomerInfo from './FixCustomerInfo';

interface InfoProps {
  isMemoModalOpen: boolean;
  setIsMemoModalOpen: (value: boolean) => void;
  isModalOpen: boolean;
  setIsModalOpen: (value: boolean) => void;
}
const Info = ({
  isMemoModalOpen,
  setIsMemoModalOpen,
  isModalOpen,
  setIsModalOpen
}: InfoProps) => {
  const personId = sessionStorage.getItem('personId') ?? '';
  const { data: member } = useGetMember(personId);

  const [memoResult, setMemoResult] = useState('');

  const { data } = useGetMemberMemo(personId);

  useEffect(() => {
    if (data) {
      setMemoResult(data);
    }
  }, [data]);

  const formatPhoneNumber = (phoneNumber: string): string => {
    if (!phoneNumber) return '';
    // 문자열이 숫자 11자리일 경우에만 포맷팅
    const cleaned = phoneNumber.replace(/\D/g, ''); // 숫자가 아닌 문자를 제거

    // 11자리로 길이 확인
    const match = cleaned.match(/^(\d{3})(\d{4})(\d{4})$/);

    // 정규 표현식으로 분리한 후, 포맷팅하여 반환
    if (match) {
      return `${match[1]}-${match[2]}-${match[3]}`;
    }

    return phoneNumber; // 포맷팅되지 않은 경우 원래 값을 반환
  };

  const actionText = memoResult ? '수정' : '등록';

  return (
    <div style={{ width: '100%' }}>
      <Container6>
        {isMemoModalOpen && (
          <CustomerMemo
            setIsMemoModalOpen={setIsMemoModalOpen}
            setMemoResult={setMemoResult}
            memoResult={memoResult}
          />
        )}
        {isModalOpen && <FixCustomerInfo setIsModalOpen={setIsModalOpen} />}
        <CustomText>기본 정보</CustomText>
        {member?.status === 'TAKEN' ? (
          <ButtonText onClick={() => setIsModalOpen(true)}>수정</ButtonText>
        ) : null}
      </Container6>
      <Container5>
        <Container8>
          <div className="flex items-center gap-20">
            <DefaultInfoText>성함</DefaultInfoText>
            <DefaultInfoText2>{member?.name ?? '-'}</DefaultInfoText2>
          </div>
          <div className="flex items-center gap-20">
            <DefaultInfoText>나이·성별</DefaultInfoText>
            <DefaultInfoText2>
              {dayjs().diff(dayjs(member?.birthday ?? '-'), 'year')}세{' '}
              {member?.sex === 'MALE' ? ' · 남성' : ' · 여성'}
            </DefaultInfoText2>
          </div>
          <div className="flex items-center gap-20">
            <DefaultInfoText>연락처</DefaultInfoText>
            <DefaultInfoText2>
              {formatPhoneNumber(member?.phone || '') ?? '-'}
            </DefaultInfoText2>
          </div>
          <div className="flex items-center gap-20">
            <DefaultInfoText>피벗 가입여부</DefaultInfoText>
            <DefaultInfoText2>
              {member?.status === 'TAKEN' ? '미가입' : '가입'}
            </DefaultInfoText2>
          </div>
        </Container8>
      </Container5>
      <RowDivider></RowDivider>
      <Container6>
        <CustomText>회원 메모</CustomText>
        <ButtonText onClick={() => setIsMemoModalOpen(true)}>
          {actionText}
        </ButtonText>
      </Container6>
      <CustomTextArea defaultValue={memoResult} />
      <RowDivider></RowDivider>
      <Container8 style={{ gap: 16, margin: 16 }}>
        <CustomText>사전 정보</CustomText>
        <AdvanceInfo />
      </Container8>
    </div>
  );
};

export default Info;
